import React from 'react';
import { buildTherapyHref, getActivePromoEvents, PromoEvent } from '../../data/events';
import './home.css';

const now = new Date();
const activeEvents = getActivePromoEvents(now);
const featuredEvent = activeEvents[0] ?? null;
const upcomingEvents = activeEvents.slice(1);

const Home = () => {
    const renderCtaButton = (event: PromoEvent, className: string) => {
        const { action, ctaLabel } = event;
        const isExternal = action.href.startsWith('http');
        return (
            <a
                className={className}
                href={action.href}
                {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                aria-label={`${ctaLabel} für ${event.title}`}
            >
                {ctaLabel}
            </a>
        );
    };

    return (
        <div className="section sectionFillViewport" id="home">
            {featuredEvent && (
                <div className="eventBanner" role="note">
                    {featuredEvent.day && featuredEvent.month && (
                        <div className="eventBannerDate" aria-label={`${featuredEvent.day}. ${featuredEvent.month}`}>
                            <span className="eventBannerDay">{featuredEvent.day}</span>
                            <span className="eventBannerMonth">{featuredEvent.month}</span>
                        </div>
                    )}
                    <div className="eventBannerBody">
                        <span className="eventBannerBadge">{featuredEvent.badge}</span>
                        <p className="eventBannerTitle">{featuredEvent.title}</p>
                        <p className="eventBannerDesc">{featuredEvent.desc}</p>
                        {featuredEvent.moreTherapyId && (
                            <a className="eventBannerMoreLink" href={buildTherapyHref(featuredEvent.moreTherapyId)}>Mehr zur Methode</a>
                        )}
                    </div>
                    {renderCtaButton(featuredEvent, 'eventBannerCta')}
                </div>
            )}
            <div className="homeHero" role="banner">
                <div className={`homeHeroInner${upcomingEvents.length > 0 ? ' homeHeroInnerSplit' : ''}`}>
                    <div className="homeCard">
                        <p className="homeKicker">Naturheilpraxis &bull; Regensburg</p>
                        <h1 className="homeTitle">Nadja L&ouml;we</h1>
                        <p className="homeLead">
                            Ganzheitliche Naturheilkunde &ndash; zur Unterst&uuml;tzung und m&ouml;glichen Linderung von Beschwerden,
                            individuell auf Sie abgestimmt.
                        </p>
                        <div className="ctaRow">
                            <a className="buttonPrimary" href="#page-booking">
                                Termin buchen
                            </a>
                            <a className="buttonSecondary" href="/#page-therapies">
                                Therapien &amp; Methoden
                            </a>
                            <a className="buttonSecondary" href="#page-contact">
                                Kontakt aufnehmen
                            </a>
                        </div>
                    </div>
                    {upcomingEvents.length > 0 && (
                        <div className="upcomingCard" aria-label="Weitere Veranstaltungen">
                            <p className="upcomingCardHeading">Weitere Termine &amp; Aktionen</p>
                            {upcomingEvents.map(ev => (
                                <div key={ev.id} className="upcomingRow">
                                    {ev.day && ev.month ? (
                                        <div className="upcomingRowDate" aria-label={`${ev.day}. ${ev.month}`}>
                                            <span className="upcomingRowDay">{ev.day}</span>
                                            <span className="upcomingRowMonth">{ev.month}</span>
                                        </div>
                                    ) : (
                                        <div className="upcomingRowDatePlaceholder" aria-hidden="true" />
                                    )}
                                    <div className="upcomingRowBody">
                                        <span className="upcomingRowTitle">{ev.title}</span>
                                        {ev.time && <span className="upcomingRowTime">{ev.time}</span>}
                                        <span className="upcomingRowDesc">{ev.desc}</span>
                                    </div>
                                    {renderCtaButton(ev, 'upcomingRowCta')}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
export default Home;